<template>
  <div class="table-responsive">
    <div class="container-table">
      <table class="table table-striped- table-bordered table-hover table-checkable">
        <thead>
          <tr>
            <th nowrap class="text-center align-middle">ID Bônus</th>
            <th nowrap class="text-center align-middle">Tipo</th>
            <th nowrap class="text-center align-middle">Serviço</th>
            <th nowrap class="text-center align-middle">Valor</th>
            <th nowrap class="text-center align-middle">Início</th>
            <th nowrap class="text-center align-middle">Expiração</th>
            <th nowrap class="text-center align-middle">Produto</th>
            <th nowrap class="text-center align-middle" width="30">Motivo</th>
            <th nowrap class="text-center align-middle" width="30">Ações</th>
          </tr>
        </thead>
        <tbody v-for="(discountAddition, id) in data" :key="id">
          <tr v-for="(service, id) in discountAddition.services" :key="id">
            <td
              class="text-center align-middle"
              v-b-tooltip.hover
              :title="discountAddition.user ? 'Criado por: ' + discountAddition.user.name : '-'"
            >
              {{ discountAddition.id }}
            </td>
            <td class="text-center align-middle">
              {{ discountAddition.type === 1 ? 'Desconto' : 'Acréscimo' }}
            </td>
            <td class="text-center align-middle">
              {{ service.service.type }}
            </td>
            <td class="text-center align-middle">
              {{ service.value | money }}
            </td>
            <td class="text-center align-middle">{{ discountAddition.start_date | month }}</td>
            <td class="text-center align-middle">{{ discountAddition.end_date | month }}</td>
            <td class="text-center align-middle">
              {{ discountAddition.product ? discountAddition.product.name : '-' }}
            </td>
            <td class="text-center align-middle">
              <i
                class="fa fa-exclamation-circle"
                v-b-tooltip.hover
                :title="discountAddition.reason ? discountAddition.reason.reason : '-'"
              ></i>
            </td>
            <td class="text-center align-middle">
              <a
                href=""
                @click.prevent.stop="confirmDel(discountAddition.id, service.id)"
                class="icon-circle"
                :class="{ disabled: discountAddition.status > 1 }"
                v-b-tooltip.hover
                :title="discountAddition.type === 1 ? 'Excluir Desconto' : 'Excluir Acréscimo'"
              >
                <i class="fas fa-trash"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { returnMessageMixin } from '@/mixins/returnMessageMixin';

import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageMixin],
  name: 'InfoDiscountAddition',
  components: {},
  props: {
    customerId: Number,
  },
  data() {
    return {
      data: {},
      filters: {
        id: localStorage.customerFilterId ? localStorage.customerFilterId : '',
      },
    };
  },
  methods: {
    setStorageFilters() {
      localStorage.setItem('customerFilterId', this.filters.id);
    },
    convertFilters() {
      const filters = `?page=${this.page ? this.page : 1}&id=${
        this.filters.id ? this.filters.id : ''
      }`;
      return filters;
    },
    callData() {
      this.data.current_page = 0;
      this.setStorageFilters();
      this.getDatas();
    },
    getDatas() {
      this.getCustomersPendingDiscountAddition();
    },
    getCustomersPendingDiscountAddition() {
      const url = `${baseApiUrl}/v1/customer/${this.customerId}/discounts-additions`;

      axios
        .get(url)
        .then((res) => {
          this.data = res.data;
        })
        .catch((error) => {
          this.logMessageFormFailed(error.response);
        });
    },
    confirmDel(id, serviceId) {
      this.dialog = '';
      this.$bvModal
        .msgBoxConfirm(
          'Tem certeza que deseja excluir esse desconto / acréscimo? Caso ele ja tenha sido utilizado alguma vez, será cancelado.',
          {
            size: 'md',
            contentClass: 'p-3',
            bodyClass: 'modal-body-fix',
            buttonSize: 'md',
            okVariant: 'danger',
            okTitle: 'Confirmar exclusão',
            cancelTitle: 'Cancelar',
            cancelVariant: 'metal',
            footerClass: 'p-4',
            hideHeaderClose: true,
            centered: true,
          }
        )
        .then((value) => {
          if (value == true) {
            this.del(id, serviceId);
          } else {
            this.$toasted.show(
              '<i class="fas fa-exclamation-triangle"></i> O desconto / acréscimo não foi excluído!',
              {
                theme: 'toasted-primary',
                type: 'info',
                position: 'top-right',
                duration: 5000,
              }
            );
          }
        });
    },
    del(id, serviceId) {
      const url = `${baseApiUrl}/v1/customer/discount-addition/delete/${id}/${serviceId}`;
      axios
        .delete(url)
        .then((res) => {
          this.logMessage(res);
          this.getDatas();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
  },
  watch: {
    amount() {
      if (this.page === 1) {
        this.callData();
      } else {
        this.page = 1;
      }
    },
  },
  mounted() {
    this.getDatas();
    window.scroll(0, 0);
  },
};
</script>
